import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.496 3.75 3.75 3.75 0 016.496-3.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.496 3.75 3.75 3.75 0 016.496-3.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.495 20.25a7.5 7.5 0 11-12.99 7.5 7.5 7.5 0 0112.99-7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.457 11.715h6.202l2.81 4.868-3.1 5.37a4.5 4.5 0 000 4.5l2.866 4.964-2.812 4.868H33.69a4.502 4.502 0 00-3.898 2.25L26.927 43.5h-5.62l-2.866-4.966a4.502 4.502 0 00-3.898-2.25H8.34l-2.81-4.866 3.1-5.372a4.5 4.5 0 000-4.5l-2.866-4.964 2.812-4.868h5.732a4.502 4.502 0 003.898-2.25L21.073 4.5h5.62l2.866 4.964a4.502 4.502 0 003.898 2.25z",
    clipRule: "evenodd"
  }))
};
export var Settings = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});